import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

/**
 * صورة المنتج مع بديل ثابت: لو الصورة غير موجودة أو فشل تحميلها
 * يظهر خلفية ثابتة واسم المنتج في المنتصف.
 */
const ProductImage = ({ src, name, className, textClassName = 'text-base md:text-xl' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <div
        role="img"
        aria-label={name}
        className={cn(
          'flex items-center justify-center p-2 text-center bg-gradient-to-br from-burgundy-500 to-burgundy-600',
          className
        )}
      >
        <span className={cn('font-tajawal font-bold text-white leading-snug line-clamp-3 drop-shadow-sm', textClassName)}>
          {name}
        </span>
      </div>
    );
  }

  return <img src={src} alt={name} onError={() => setFailed(true)} className={className} />;
};

export default ProductImage;
